import { createFileRoute } from "@tanstack/react-router";

import { ReturnPage } from "../../../../features/purchasing/return-page";

export const Route = createFileRoute("/_app/purchasing/returns/$id")({ component: Page });

function Page() {
  const { id } = Route.useParams();
  return <ReturnPage key={id} id={id} />;
}
